import { render } from "./DataAdapter.vue?vue&type=template&id=9d1de7b4"
import script from "./DataAdapter.vue?vue&type=script&lang=js"
export * from "./DataAdapter.vue?vue&type=script&lang=js"

import "./DataAdapter.vue?vue&type=style&index=0&id=9d1de7b4&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/views/project/data-adapters/DataAdapter.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "9d1de7b4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('9d1de7b4', __exports__)) {
    api.reload('9d1de7b4', __exports__)
  }
  
  module.hot.accept("./DataAdapter.vue?vue&type=template&id=9d1de7b4", () => {
    api.rerender('9d1de7b4', render)
  })

}


export default __exports__